import React from "react";
import ReactMarkdown from "react-markdown";
import { List, ListItem } from "../List";
import { Heading, Text } from "../Type";

interface RenderMarkdownProps {
  /** Markdown content to render */
  content: string;
  /** Custom class name */
  className?: string;
}

/**
 * Component mapping HTML elements to our components
 */
const RenderMarkdown: React.FC<RenderMarkdownProps> = ({
  content,
  className,
}) => {
  return (
    <div className={className}>
      <ReactMarkdown
        components={{
          // Map headings to the Heading component
          h1: ({ children }) => (
            <Heading as="h1" size="base" className="mb-md">
              {children}
            </Heading>
          ),
          h2: ({ children }) => (
            <Heading as="h2" size="sm" className="mb-md">
              {children}
            </Heading>
          ),
          h3: ({ children }) => (
            <Heading as="h3" size="x-sm" className="mb-md">
              {children}
            </Heading>
          ),
          // Map paragraphs to the Text component
          p: ({ children }) => (
            <Text as="p" size="base" theme="base" className="mb-md">
              {children}
            </Text>
          ),
          // Map code elements
          code: ({ children }) => (
            <Text as="code" family="mono" size="sm" className="mb-md">
              {children}
            </Text>
          ),
          // Map unordered lists
          ul: ({ children }) => (
            <List theme="bullet" className="mb-md">
              {children}
            </List>
          ),
          // Map ordered lists
          ol: ({ children }) => (
            <List theme="decimal" className="mb-md">
              {children}
            </List>
          ),
          // Map list items
          li: ({ children }) => <ListItem>{children}</ListItem>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default RenderMarkdown;
